<template>
  <li class="flex-row" @click="onClick()" :class="{ active }">
    <div class="icon" :class="{ active }">
      <font-awesome-icon :icon="['fas', icon]" />
    </div>
    <div class="flex-column">
      <div class="title">{{ $t(title) }}</div>
      <div class="desc">{{ $t(description) }}</div>
    </div>
  </li>
</template>

<script setup>
import { useRoute } from "vue-router";

const route = useRoute();

const props = defineProps({
  icon: {
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["click"]);

const onClick = () => {
  emit("click");
};
</script>

<style scoped lang="scss">
li {
  padding: 8px;
  border-radius: 8px;

  &::before {
    display: none;
  }

  &.active {
    background: var(--gray50);
  }

  &:hover {
    background: var(--gray50);
    cursor: pointer;
  }

  .icon {
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    width: 24px;
    color: var(--brandPrimary);

    &.active {
      color: var(--brandSecondary);
    }

    svg {
      display: block;
    }
  }

  .title {
    font-weight: 700;
    margin-bottom: 6px;
  }

  .desc {
    font-size: 10px;
    color: var(--gray600);
  }

  .mobile-show {
    display: none;
  }
}
</style>
